import Chroma from "chroma-js"

const MAX_LUMINANCE = 0.99 // color near white
const MIN_LUMINANCE = 0.02 // color near black

type TGetPaletteByColor = {
  color50?: string
  color100?: string
  color200?: string
  color300?: string
  color400?: string
  color500?: string
  color600?: string
  color700?: string
  color800?: string
  color900?: string
}

const preparePalette = (palette: string[]): TGetPaletteByColor => {
  return Object.values(palette).reduce((acc, item, index) => {
    const key = `color${index === 0 ? 50 : index * 100}`
    acc[key] = item
    return acc
  }, {})
}

export const getPaletteByColor = (color: string): TGetPaletteByColor => {
  try {
    const firstColor = Chroma(color).set("hsl.s", 0.8).set("hsl.l", 0.93).hex()
    const lastColor = Chroma(color).set("hsl.s", 0.25).set("hsl.l", 0.15).hex()

    const luminance = Chroma(color).luminance()

    let lightScale = [firstColor, color]
    let darkScale = [color, lastColor]

    if (luminance > MAX_LUMINANCE) {
      lightScale = [lastColor, color]
    } else if (luminance < MIN_LUMINANCE) {
      darkScale = [color, firstColor]
    }

    const lightColors = Chroma.scale(lightScale).correctLightness().colors(6)
    const darkColors = Chroma.scale(darkScale).correctLightness().colors(5)
    const [, ...restColors] = darkColors
    const resultPalette = [...lightColors, ...restColors]

    return preparePalette(resultPalette)
  } catch {
    return {
      color50: "",
      color100: "",
      color200: "",
      color300: "",
      color400: "",
      color500: "",
      color600: "",
      color700: "",
      color800: "",
      color900: "",
    }
  }
}
